var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.998 4.066a2.6 2.6 0 1 0 0 5.2 2.6 2.6 0 0 0 0-5.2Zm-1.4 2.6a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m7.665 15.832.333-.499-.333.5a.6.6 0 0 0 .666 0l-.333-.5.333.5.001-.001.001-.001.005-.003.015-.01a10.383 10.383 0 0 0 .255-.18 20.882 20.882 0 0 0 2.826-2.476c1.524-1.608 3.164-3.921 3.164-6.496a6.6 6.6 0 1 0-13.2 0c0 2.575 1.641 4.888 3.165 6.496a20.883 20.883 0 0 0 3.026 2.618l.055.038.015.01.004.003.002.001ZM4.18 2.848a5.4 5.4 0 0 1 9.218 3.818c0 2.093-1.359 4.113-2.835 5.671a19.688 19.688 0 0 1-2.565 2.26 19.685 19.685 0 0 1-2.564-2.26C3.958 10.78 2.598 8.76 2.598 6.667A5.4 5.4 0 0 1 4.18 2.847Z",
    fill: "currentColor"
  })));
};
export default SvgLocation;